import { render, staticRenderFns } from "./v-navbar.vue?vue&type=template&id=b47e70f2&scoped=true&"
import script from "./v-navbar.vue?vue&type=script&lang=js&"
export * from "./v-navbar.vue?vue&type=script&lang=js&"
import style0 from "./v-navbar.vue?vue&type=style&index=0&id=b47e70f2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b47e70f2",
  null
  
)

export default component.exports